// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"userFanId_formGroup__e2ZSL","heading":"userFanId_heading__2K2Xi","formFields":"userFanId_formFields__1BExs","inputContainer":"userFanId_inputContainer__JMD1L"};